import { tv } from 'tailwind-variants';

const alertStyles = tv({
    slots: {
        base: `
      iris:relative
      iris:flex
      iris:w-full
      iris:data-[state=closed]:[animation:fadeOut_var(--comp-motion-duration-alert)_var(--comp-motion-easing-alert)_forwards]
      iris:data-[state=open]:[animation:fadeIn_var(--comp-motion-duration-alert)_var(--comp-motion-easing-alert)_forwards]
    `,
        iconBox: `
      iris:flex
      iris:items-center
      iris:justify-center
      iris:rounded-l-(--comp-size-radius-alert)
      iris:border
      iris:border-r-0
      iris:py-(--comp-space-padding-alert-icon-vertical)
      iris:pr-(--comp-space-padding-alert-icon-right)
      iris:pl-(--comp-space-padding-alert-icon-left)
    `,
        icon: `
      iris:size-(--comp-size-icon-alert)
      iris:shrink-0
    `,
        contentBox: `
      iris:w-full
      iris:rounded-r-(--comp-size-radius-alert)
      iris:border
      iris:border-l-0
      iris:p-(--comp-space-padding-alert-content-all)
    `,
        content: `
      iris:flex
      iris:flex-1
      iris:flex-col
      iris:gap-(--comp-space-gap-alert-content)
      iris:rounded-r-(--comp-size-radius-alert)
      iris:pr-(--comp-space-padding-alert-text-right-dismissable)
    `,
        titleBox: "iris:font-(family-name:--comp-type-font-alert-title)",
        title: `
      iris:text-(length:--comp-type-size-alert-title)
      iris:leading-(--comp-type-leading-alert-title)
      iris:font-(--comp-type-weight-alert-title)
      iris:tracking-(--comp-type-tracking-alert-title)
    `,
        descriptionBox: "iris:font-(family-name:--comp-type-font-alert-body)",
        description: `
      iris:text-(length:--comp-type-size-alert-body)
      iris:leading-(--comp-type-leading-alert-body)
      iris:font-(--comp-type-weight-alert-body)
      iris:tracking-(--comp-type-tracking-alert-body)
    `,
        closeButtonBox: `
      iris:absolute iris:top-0 iris:right-0
      iris:p-(--comp-space-padding-alert-icon-vertical)
    `,
        closeButton: "",
        closeIcon: "",
    },
    variants: {
        variant: {
            info: {
                iconBox: `
          iris:border-(--comp-color-border-alert-default-info)
          iris:bg-(--comp-color-background-alert-icon-container-info)
        `,
                icon: "iris:text-(--comp-color-content-alert-icon-info)",
                contentBox: `
          iris:border-(--comp-color-border-alert-default-info)
          iris:bg-(--comp-color-background-alert-info)
        `,
                title: "iris:text-(--comp-color-content-alert-title-info)",
                description: "iris:text-(--comp-color-content-alert-body-info)",
                closeIcon: `
          iris:text-(--comp-color-content-alert-close-icon-info)
          iris:group-hover:text-(--comp-color-content-alert-close-icon-info)
          iris:group-active:text-(--comp-color-content-alert-close-icon-info)
        `,
            },
            success: {
                iconBox: `
          iris:border-(--comp-color-border-alert-default-success)
          iris:bg-(--comp-color-background-alert-icon-container-success)
        `,
                icon: "iris:text-(--comp-color-content-alert-icon-success)",
                contentBox: `
          iris:border-(--comp-color-border-alert-default-success)
          iris:bg-(--comp-color-background-alert-success)
        `,
                title: "iris:text-(--comp-color-content-alert-title-success)",
                description: "iris:text-(--comp-color-content-alert-body-success)",
                closeIcon: `
          iris:text-(--comp-color-content-alert-close-icon-success)
          iris:group-hover:text-(--comp-color-content-alert-close-icon-success)
          iris:group-active:text-(--comp-color-content-alert-close-icon-success)
        `,
            },
            caution: {
                iconBox: `
          iris:border-(--comp-color-border-alert-default-caution)
          iris:bg-(--comp-color-background-alert-icon-container-caution)
        `,
                icon: "iris:text-(--comp-color-content-alert-icon-caution)",
                contentBox: `
          iris:border-(--comp-color-border-alert-default-caution)
          iris:bg-(--comp-color-background-alert-caution)
        `,
                title: "iris:text-(--comp-color-content-alert-title-caution)",
                description: "iris:text-(--comp-color-content-alert-body-caution)",
                closeIcon: `
          iris:text-(--comp-color-content-alert-close-icon-caution)
          iris:group-hover:text-(--comp-color-content-alert-close-icon-caution)
          iris:group-active:text-(--comp-color-content-alert-close-icon-caution)
        `,
            },
            error: {
                iconBox: `
          iris:border-(--comp-color-border-alert-default-error)
          iris:bg-(--comp-color-background-alert-icon-container-error)
        `,
                icon: "iris:text-(--comp-color-content-alert-icon-error)",
                contentBox: `
          iris:border-(--comp-color-border-alert-default-error)
          iris:bg-(--comp-color-background-alert-error)
        `,
                content: "iris:pr-(--comp-space-padding-alert-text-right)",
                title: "iris:text-(--comp-color-content-alert-title-error)",
                description: "iris:text-(--comp-color-content-alert-body-error)",
                closeIcon: `
          iris:text-(--comp-color-content-alert-close-icon-error)
          iris:group-hover:text-(--comp-color-content-alert-close-icon-error)
          iris:group-active:text-(--comp-color-content-alert-close-icon-error)
        `,
            },
        },
        inverse: {
            true: "",
            false: "",
        },
    },
    compoundVariants: [
        {
            variant: "info",
            inverse: true,
            class: {
                iconBox: `
          iris:border-(--comp-color-border-alert-inverse-info)
          iris:bg-(--comp-color-background-alert-icon-container-inverse-info)
        `,
                icon: "iris:text-(--comp-color-content-alert-icon-inverse-info)",
                contentBox: `
          iris:border-(--comp-color-border-alert-inverse-info)
          iris:bg-(--comp-color-background-alert-inverse-info)
        `,
                title: "iris:text-(--sem-color-content-info-inverse-primary)",
                description: "iris:text-(--comp-color-content-alert-body-inverse-info)",
                closeIcon: `
          iris:text-(--comp-color-content-alert-close-icon-inverse-info)
          iris:group-hover:text-(--comp-color-content-alert-close-icon-inverse-info)
          iris:group-active:text-(--comp-color-content-alert-close-icon-inverse-info)
        `,
            },
        },
        {
            variant: "success",
            inverse: true,
            class: {
                iconBox: `
          iris:border-(--comp-color-border-alert-inverse-success)
          iris:bg-(--comp-color-background-alert-icon-container-inverse-success)
        `,
                icon: "iris:text-(--comp-color-content-alert-icon-inverse-success)",
                contentBox: `
          iris:border-(--comp-color-border-alert-inverse-success)
          iris:bg-(--comp-color-background-alert-inverse-success)
        `,
                title: "iris:text-(--sem-color-content-success-inverse-primary)",
                description: "iris:text-(--comp-color-content-alert-body-inverse-success)",
                closeIcon: `
          iris:text-(--comp-color-content-alert-close-icon-inverse-success)
          iris:group-hover:text-(--comp-color-content-alert-close-icon-inverse-success)
          iris:group-active:text-(--comp-color-content-alert-close-icon-inverse-success)
        `,
            },
        },
        {
            variant: "caution",
            inverse: true,
            class: {
                iconBox: `
          iris:border-(--comp-color-border-alert-inverse-caution)
          iris:bg-(--comp-color-background-alert-icon-container-inverse-caution)
        `,
                icon: "iris:text-(--comp-color-content-alert-icon-inverse-caution)",
                contentBox: `
          iris:border-(--comp-color-border-alert-inverse-caution)
          iris:bg-(--comp-color-background-alert-inverse-caution)
        `,
                title: "iris:text-(--sem-color-content-caution-inverse-primary)",
                description: "iris:text-(--comp-color-content-alert-body-inverse-caution)",
                closeIcon: `
          iris:text-(--comp-color-content-alert-close-icon-inverse-caution)
          iris:group-hover:text-(--comp-color-content-alert-close-icon-inverse-caution)
          iris:group-active:text-(--comp-color-content-alert-close-icon-inverse-caution)
        `,
            },
        },
        {
            variant: "error",
            inverse: true,
            class: {
                iconBox: `
          iris:border-(--comp-color-border-alert-inverse-error)
          iris:bg-(--comp-color-background-alert-icon-container-inverse-error)
        `,
                icon: "iris:text-(--comp-color-content-alert-icon-inverse-error)",
                contentBox: `
          iris:border-(--comp-color-border-alert-inverse-error)
          iris:bg-(--comp-color-background-alert-inverse-error)
        `,
                title: "iris:text-(--sem-color-content-error-inverse-primary)",
                description: "iris:text-(--comp-color-content-alert-body-inverse-error)",
                closeIcon: `
          iris:text-(--comp-color-content-alert-close-icon-inverse-error)
          iris:group-hover:text-(--comp-color-content-alert-close-icon-inverse-error)
          iris:group-active:text-(--comp-color-content-alert-close-icon-inverse-error)
        `,
            },
        },
    ],
    defaultVariants: {
        variant: "info",
        inverse: false,
    },
});

export { alertStyles as default };
